var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bottle",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 381.522,
    height: 389.857,
    viewBox: "0 0 381.522 389.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 381.522,
    height: 389.857,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M238.2,220.783c11.063-45.41,6.495-87.174-2.088-108.835-8.451-21.328-19.432-34.129-23.3-38.221l9.872-32.06,3.521-.69a5.224,5.224,0,0,0,.512-10.127L179.5,16.54a5.145,5.145,0,0,0-6.027,2.363,5.212,5.212,0,0,0,.9,6.415l2.371,2.264-9.855,32c-5.5,1.208-21.776,5.616-40.762,18.5-21.06,14.284-49.508,42.181-65.447,93.941L59.5,175.861c2.055.677,176.364,45.241,178.7,44.921",
    transform: "translate(50.535 13.848)",
    fill: "#fffaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M208.373,124.774c-12.967-16.157-24.159-30.116-51.575-23.651-8.057,1.9-15.86,4.549-23.407,7.114-18.573,6.308-37.637,12.788-58.246,6.251L40.188,226.495a30.891,30.891,0,0,0,11.4,34.114c11.077,8.026,31.218,19.73,64.26,29.905,33.223,10.23,56.768,11.924,70.671,11.545a30.928,30.928,0,0,0,28.757-21.794l39.838-127.78c-23.364,1.411-35.649-13.894-46.739-27.712",
    transform: "translate(32.967 84.512)",
    fill: "#26cbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M154.247,96.251c-1.272.244-4.932.379-14.236-2.193q-2.965-.818-5.727-1.773l4.054-6.641-2.648-1.655c-3.826-2.391-7.995-5.239-11.17-7.636,13.3,4.2,27.947,15.634,29.728,19.9",
    transform: "translate(105.754 64.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M154.247,96.251c-1.272.244-4.932.379-14.236-2.193q-2.965-.818-5.727-1.773l4.054-6.641-2.648-1.655c-3.826-2.391-7.995-5.239-11.17-7.636C137.817,80.55,152.466,91.986,154.247,96.251Z",
    transform: "translate(105.754 64.846)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M121.508,77.694a102.243,102.243,0,0,0,12.2,8.836l-1.417,2.323a85.66,85.66,0,0,1-12.485-6.5Z",
    transform: "translate(101.753 65.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M121.508,77.694a102.243,102.243,0,0,0,12.2,8.836l-1.417,2.323a85.66,85.66,0,0,1-12.485-6.5Z",
    transform: "translate(101.753 65.986)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M111.5,70.8c.666-.468,2.338-.847,5.43-.468l-3.179,6.885c-1.751-2.251-2.65-4.159-2.65-5.45q.2-.485.4-.967",
    transform: "translate(94.354 59.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M111.5,70.8c.666-.468,2.338-.847,5.43-.468l-3.179,6.885c-1.751-2.251-2.65-4.159-2.65-5.45Q111.3,71.281,111.5,70.8Z",
    transform: "translate(94.354 59.601)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M39.675,187.956a9.389,9.389,0,0,1,1.287-8.8c4.237-5.875,14.715-8.176,32.034-7.037a163.066,163.066,0,0,1,22.277,3.569l-1.339,6.167a157.26,157.26,0,0,0-21.352-3.438c-20.082-1.322-25.221,2.657-26.5,4.431a3.177,3.177,0,0,0-.562,2.726Z",
    transform: "translate(33.217 145.94)",
    fill: "#061c59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M169.318,11.6a2.6,2.6,0,0,1,1.626,3.5L153.34,59.1a2.6,2.6,0,0,1-3.133,1.472L128,53.95l-.022-.006a2.6,2.6,0,0,1-1.764-3.072L136.981,4.546a2.6,2.6,0,0,1,3.3-1.894Z",
    transform: "translate(107.135 2.154)",
    fill: "#fc8363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M208.183,106.4c2.563-9.226-22.38-24.76-35.688-28.477-4.043-1.13-9.581-2.676-11.268,1.15a4.364,4.364,0,0,0-.4,1.276L158.1,87.8c-1.241-.956-2.4-1.909-3.434-2.839l7.543-16.337-3.739-.9c-7.571-1.823-11.86-.995-14.29.629a3.137,3.137,0,0,0-1.812,1.736l-.009.028a7.076,7.076,0,0,0-1.067,2.325c-.041.157-.061.32-.092.481-4.425,10.735-20.7,50.369-36.566,90.958-37.718,96.46-36.5,104.071-36.045,106.936,1.814,11.362,10.352,19.042,28.272,24.561a182.747,182.747,0,0,0,23.993,5.332l2.632.429.862-2.522c.209-.612,21.128-61.918,40.06-125.39a.768.768,0,0,0,.018-.142,272.716,272.716,0,0,0,25.045-33.513c9.38-14.506,18.665-33,18.711-33.167m-6.289-2.092c-1.272.244-4.93.379-14.234-2.193-1.979-.546-3.885-1.141-5.729-1.773l4.054-6.641-2.648-1.655c-3.826-2.391-7.995-5.239-11.17-7.636,13.3,4.2,27.947,15.634,29.728,19.9m-36.74-17.419a102.243,102.243,0,0,0,12.2,8.836l-1.418,2.323a85.456,85.456,0,0,1-12.483-6.5ZM147.743,73.616c.666-.468,2.338-.847,5.43-.468l-3.179,6.885c-1.751-2.251-2.65-4.159-2.65-5.45q.2-.485.4-.967",
    transform: "translate(58.144 56.642)",
    fill: "#fc8363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M153.917,228.983l-3.273-5.4c3.283-1.992,3.125-3.506,3.075-4.006-.568-5.485-15.579-16.96-56.021-31.251l2.1-5.949c26.715,9.439,58.843,23.444,60.195,36.553.283,2.73-.544,6.691-6.079,10.049",
    transform: "translate(82.975 154.897)",
    fill: "#061c59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M121.682,273.038a184.357,184.357,0,0,1-24.361-5.419c-18.852-5.8-28.163-14.06-30.2-26.772-.614-3.811-1.437-8.921,36.2-105.177l1.738-4.429c-2.432-2.829-5.391-7.281-5.108-11.943a10.182,10.182,0,0,1,9.812-9.254,9.817,9.817,0,0,1,3.419.632l2.138-5.365,1.235-.4c4.187-1.365,9.74-3.111,15.551-4.479a59.372,59.372,0,0,1,13.509-1.705c18.4,0,28.636,10.807,39.192,23.862l1.32,1.629-1.213,1.714c-2.905,4.115-5.91,8.137-8.956,11.983a10.376,10.376,0,0,1,1.577,3.234,9.548,9.548,0,0,1-.873,7.8c-2.419,4.067-7.469,6.08-11.085,7.038-15.984,52.873-32.466,99.528-37.173,112.665l-1.785,5.193Z",
    transform: "translate(56.87 83.847)",
    fill: "#5e5982"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M146.9,102.772c17.476,0,27.02,10.449,37.034,22.832-3.512,4.971-6.981,9.541-10.408,13.788a6.819,6.819,0,0,1,2.635,3.819c1.9,6.4-4.483,10.245-11.492,11.721-18.29,60.663-37.567,113.96-37.768,114.548L126.041,272l-2.63-.431a182.32,182.32,0,0,1-23.993-5.332c-17.92-5.516-26.458-13.2-28.274-24.559-.457-2.866-1.672-7.271,36.047-103.731q1.182-3.021,2.363-6.029c-4.956-5.161-8.069-11.922-2.894-16.141a6.818,6.818,0,0,1,4.388-1.69,8.542,8.542,0,0,1,4.854,1.757q1.412-3.551,2.8-7.031c5.008-1.631,10.108-3.185,15.327-4.414a56.113,56.113,0,0,1,12.875-1.631m0-5.548A62.052,62.052,0,0,0,132.754,99c-5.9,1.389-11.527,3.155-15.771,4.54l-2.473.8-.962,2.415q-.38.949-.76,1.9a12.2,12.2,0,0,0-1.74-.124,12.424,12.424,0,0,0-7.895,2.939A12.257,12.257,0,0,0,98.47,120.4c-.3,4.88,2.228,9.4,4.7,12.6q-.574,1.462-1.147,2.926C64.109,232.893,64.931,237.987,65.655,242.483c2.2,13.777,12.407,22.989,32.13,29.06a186.667,186.667,0,0,0,24.733,5.505l2.63.429,4.627.756,1.516-4.437.864-2.524.137-.381c4.664-13.015,20.9-58.954,36.794-111.389,3.9-1.234,8.69-3.562,11.249-7.86a12.267,12.267,0,0,0,1.147-10.016,13.953,13.953,0,0,0-.873-2.234c2.672-3.427,5.306-6.974,7.86-10.589l2.423-3.427-2.639-3.264c-11.013-13.618-21.726-24.89-41.349-24.89",
    transform: "translate(55.589 82.573)",
    fill: "#061c59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M167.364,216.946c-1.576,5.117-29.25,4.438-60.668-5.235s-54.678-24.683-53.1-29.8,23.991,13.9,55.407,23.575,59.94,6.343,58.364,11.46",
    transform: "translate(45.452 153.769)",
    fill: "#061c59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M170.483,14.876a2.456,2.456,0,0,1,1.537,3.308L155.374,59.8a2.458,2.458,0,0,1-2.963,1.393l-21-6.264-.02-.006a2.458,2.458,0,0,1-1.67-2.905L139.9,8.211a2.455,2.455,0,0,1,3.116-1.792Zm1.857-6.032L144.877.386a8.768,8.768,0,0,0-11.12,6.393L123.573,50.588a8.8,8.8,0,0,0,5.958,10.363l.028.009.048.015,21,6.264a8.762,8.762,0,0,0,10.574-4.971l.028-.063.024-.063,16.629-41.571a8.769,8.769,0,0,0-5.522-11.728",
    transform: "translate(104.759 0)",
    fill: "#fc8363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M136.707,10.6a1.6,1.6,0,0,1-2.09.751c-.939-.288-1.524-1.093-1.307-1.8a1.606,1.606,0,0,1,2.092-.751c.938.29,1.522,1.095,1.306,1.8",
    transform: "translate(113.182 7.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M144.086,10.407a2.137,2.137,0,0,1-2.787,1c-1.252-.385-2.031-1.457-1.742-2.395a2.137,2.137,0,0,1,2.787-1c1.252.385,2.031,1.457,1.742,2.395",
    transform: "translate(118.476 6.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M134.746,14.435c-.361,1.172.677,2.534,2.319,3.038s3.264-.035,3.625-1.208-.677-2.534-2.317-3.038-3.266.035-3.626,1.208",
    transform: "translate(114.379 11.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M144.329,14.426a1.049,1.049,0,1,1-.729-1.154.97.97,0,0,1,.729,1.154",
    transform: "translate(120.867 11.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M137.072,28.165a2.073,2.073,0,1,0,2.591-1.37,2.073,2.073,0,0,0-2.591,1.37",
    transform: "translate(116.338 22.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M132.182,28.676a1.036,1.036,0,1,0,1.3-.686,1.037,1.037,0,0,0-1.3.686",
    transform: "translate(112.224 23.733)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M136.576,19.3a1.036,1.036,0,1,0,1.3-.686,1.037,1.037,0,0,0-1.3.686",
    transform: "translate(115.956 15.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M142.5,18.951a1.214,1.214,0,1,1-.7-1.764,1.357,1.357,0,0,1,.7,1.764",
    transform: "translate(119.035 14.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M131.337,16.4c-.17.547.327,1.185,1.11,1.426s1.55-.007,1.722-.555-.331-1.185-1.113-1.426-1.55.007-1.718.555",
    transform: "translate(111.517 13.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M139.317,5.488c-.346,1.121-1.855,1.651-3.371,1.185s-2.465-1.755-2.119-2.876,1.855-1.653,3.371-1.185,2.465,1.755,2.119,2.876",
    transform: "translate(113.599 2.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M148.4,9.871A2.073,2.073,0,1,0,150.994,8.5,2.073,2.073,0,0,0,148.4,9.871",
    transform: "translate(125.961 7.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M148.978,8.368c-.294.954-1.655,1.383-3.04.956s-2.271-1.546-1.977-2.5,1.655-1.383,3.042-.956,2.269,1.546,1.975,2.5",
    transform: "translate(122.219 4.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M136.08,26.693c-.264.86-1.748,1.167-3.31.686s-2.615-1.57-2.35-2.43,1.746-1.165,3.31-.684,2.615,1.568,2.35,2.428",
    transform: "translate(110.731 20.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M142.236,34.66c-.4,1.285-2.421,1.8-4.523,1.154s-3.488-2.214-3.092-3.5,2.421-1.8,4.523-1.154,3.49,2.214,3.092,3.5",
    transform: "translate(114.277 26.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M132.442,31.862a2.481,2.481,0,1,1-1.642-3.1,2.478,2.478,0,0,1,1.642,3.1",
    transform: "translate(108.363 24.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M126.741,24.435A1.807,1.807,0,1,1,128,26.373a1.65,1.65,0,0,1-1.263-1.938",
    transform: "translate(107.595 19.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M129.664,11.643a1.489,1.489,0,1,1,1.023,1.709,1.413,1.413,0,0,1-1.023-1.709",
    transform: "translate(110.078 9.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M140.749,30.367a1.652,1.652,0,1,0,3.114.958,1.652,1.652,0,1,0-3.114-.958",
    transform: "translate(119.454 24.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M147.765,18.46a1.777,1.777,0,1,1-1.176-2.221,1.778,1.778,0,0,1,1.176,2.221",
    transform: "translate(122.545 13.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M144.435,21.494a1.629,1.629,0,1,0,2.036-1.078,1.629,1.629,0,0,0-2.036,1.078",
    transform: "translate(122.608 17.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M147.038,14.411a3,3,0,0,0,5.661,1.744,3,3,0,0,0-5.661-1.744",
    transform: "translate(124.799 10.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M135.8,9.158a3.11,3.11,0,1,1-2.056-3.887A3.107,3.107,0,0,1,135.8,9.158",
    transform: "translate(110.169 4.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M134.939,124.35a3.486,3.486,0,0,0-4.165-2.639,57.335,57.335,0,0,1-20.405.061,13.257,13.257,0,0,1-.348,6.918,64.334,64.334,0,0,0,22.279-.176,3.486,3.486,0,0,0,2.639-4.165",
    transform: "translate(93.441 103.297)",
    fill: "#fffaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M124.535,144.005a5.311,5.311,0,0,0,4.594-2.916v0l-.013,0a.619.619,0,0,0,.035-.052,8.77,8.77,0,0,0,.481-1.143h0a13.045,13.045,0,0,0,.137-6.979l-.028-.006a8.455,8.455,0,0,0-1.81-3.124c-5.158-5.574-11.111-4.742-15.035-3.2A42.923,42.923,0,0,1,97.044,110a3.487,3.487,0,0,0-6.129,3.327A49.476,49.476,0,0,0,107.3,131.265l-.017.015c3.832,2.707,7.442,5.448,7.442,5.448a40.656,40.656,0,0,1-9.1-4.015c-5.676,5.012-16.444,15.78-19.6,27.778-1.642,6.241-.085,9.369,1.511,10.894a5.82,5.82,0,0,0,2.313,1.361,6.812,6.812,0,0,0,4.056-.083c4.031-1.261,9.274-6.491,13.923-16.96a99.593,99.593,0,0,1,2.3-14.8,91.2,91.2,0,0,0-.658,12.908,45.415,45.415,0,0,0,3.943,16.688c2.219,4.566,4.686,6.38,6.709,7a6.434,6.434,0,0,0,1.535.276,6.253,6.253,0,0,0,5.666-3.179c2.783-4.461,3-14.8-3.63-30.641a6.189,6.189,0,0,0,.843.046M92.324,165.8a10.506,10.506,0,0,1,.446-3.532c1.916-7.29,7.488-14.345,12.361-19.412-4.8,16.032-10.648,21.751-12.806,22.944m30.639-26.55c.627-5.74-2.308-7.329-2.308-7.329l-1.807-1.79c6.659.362,4.115,9.119,4.115,9.119m-1.317,31.174a10.523,10.523,0,0,1-1.964-2.97c-3.294-6.778-3.663-15.76-3.266-22.78,6.8,15.292,6.088,23.44,5.23,25.75",
    transform: "translate(72.469 91.875)",
    fill: "#fffaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M86.757,105.037a3.7,3.7,0,0,1-3.268-5.424c.662-1.252,16.549-30.839,47.858-45.95a3.7,3.7,0,0,1,3.216,6.661C105.5,74.35,90.182,102.783,90.03,103.069a3.7,3.7,0,0,1-3.273,1.968",
    transform: "translate(70.545 45.263)",
    fill: "#26cbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M381.522,193.68c-16.383-7.447-25.659-18.144-33.112-26.737-11.4-13.147-17.677-20.389-40.934-12.176-36.309,12.819-51.971-6.709-65.8-23.937-13.089-16.311-24.389-30.4-52.062-23.875-8.133,1.918-16.011,4.594-23.629,7.181-24.026,8.163-48.872,16.609-76.763-2.687-13.607-9.413-27.224-3.36-42.994,3.645C31.608,121.59,16.477,128.3,0,122.812c0,0,28.452-11.961,41.73-17.861,16.442-7.3,35.083-15.582,53.811-2.628,23.292,16.113,43.49,9.254,66.878,1.307,7.867-2.674,16-5.437,24.653-7.477,34.469-8.126,49.772,10.92,63.263,27.73,13.724,17.1,24.568,30.619,53.447,20.418,30.384-10.726,41.373,1.949,53.012,15.37,7.1,8.185,24.729,34.007,24.729,34.007",
    transform: "translate(0 80.021)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M249.4,146.73,210.225,273.949a24.913,24.913,0,0,1-23.168,17.55c-13.559.37-36.594-1.3-69.308-11.379C85.222,270.1,65.525,258.678,54.73,250.855a24.869,24.869,0,0,1-9.178-27.468l34.931-113.44a58.747,58.747,0,0,1-6.1-1.624L39.52,221.531a31.182,31.182,0,0,0,11.506,34.436c11.181,8.1,31.512,19.915,64.864,30.186,33.535,10.326,57.3,12.037,71.339,11.654a31.222,31.222,0,0,0,29.029-22l39.27-127.528c.15-.483.281-.956.425-1.437a46.978,46.978,0,0,1-6.552-.113",
    transform: "translate(32.389 92)",
    fill: "#9187a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M65.621,177.44l1.1-3.562c15.347-49.839,42.556-76.659,62.678-90.385,21.822-14.883,40.283-18.034,40.463-18.064l1.936-.313,12.135-39.4-1.9-1.81,38.676,11.721-2.939.575L206.233,73.668l-.571,1.873,1.417,1.346c.135.128,13.624,13.119,23.294,37.7,8.274,21.028,15.235,54.817,3.943,99.391a40.3,40.3,0,0,0,6.6-.377c11.063-45.41,3.787-79.994-4.8-101.654-8.451-21.328-19.431-34.129-23.3-38.223l9.873-32.06,3.519-.688a5.224,5.224,0,0,0,.512-10.127L179.5,16.539a5.146,5.146,0,0,0-6.029,2.365,5.209,5.209,0,0,0,.9,6.413l2.371,2.265-9.855,32c-5.5,1.209-21.776,5.618-40.762,18.5-21.06,14.286-49.508,42.181-65.447,93.941L59.5,175.862a48.19,48.19,0,0,0,6.119,1.577",
    transform: "translate(50.535 13.847)",
    fill: "#26cbbe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/bottle.138f670a0095e5d4fefcf88d1bea53b4.svg";
export { ForwardRef as ReactComponent };